const SkeletonRow = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="h-4 w-32 rounded bg-gray-200" />
      <div className="h-4 w-24 rounded bg-gray-200" />
    </div>
  );
};
export default SkeletonRow;
